import { Component, forwardRef, Input, OnInit } from "@angular/core";
import * as moment from "moment";
import { Moment } from "moment";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

export const BASE_CALENDAR_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BaseCalendarComponent),
  multi: true,
};

@Component({
  selector: "host-base-calendar",
  templateUrl: "base-calendar.component.html",
  styleUrls: ["./base-calendar.component.scss"],
  providers: [BASE_CALENDAR_VALUE_ACCESSOR],
})
export class BaseCalendarComponent implements OnInit, ControlValueAccessor {
  @Input() cellWidth = 36;
  @Input() cellHeight = 34;
  @Input() columns = 2;
  @Input() continuous = true; // 连选或者点选

  selectedDates = new Set<string>([]);

  currentRange = new Array(this.columns).fill(0).map((v, index) => moment().add(index, "month"));
  _registerOnChange: (value: any) => void = (_: any) => {};
  constructor() {}

  ngOnInit() {
    console.log("currentRange: ", this.currentRange);
  }

  isSelected(day) {
    return this.selectedDates.has(day.title);
  }

  isAnotherMonth(day) {
    return day.isLastMonth || day.isNextMonth;
  }

  isInRange() {
    return false;
  }

  isDisabledDate(date) {
    return false;
  }

  onClickCell(day) {
    if (this.continuous) {
      this.handleContinuousClick(day);
    } else {
      this.handleClick(day);
    }
    this._registerOnChange(Array.from(this.selectedDates));
    console.log("click cell: selected: ", this.selectedDates);
  }

  onClickArrow(direction: "next" | "prev") {
    this.currentRange = this.currentRange.map((month) =>
      direction === "next" ? month.add(1, "month") : month.subtract(1, "month"),
    );
  }

  private handleClick(day) {
    if (this.selectedDates.has(day.title)) {
      this.selectedDates.delete(day.title);
    } else {
      this.selectedDates.add(day.title);
    }
  }

  private handleContinuousClick(day) {
    if (this.selectedDates.size === 0) {
      this.selectedDates.add(day.title);
    } else {
      if (this.selectedDates.size === 1) {
        const _start = moment(Array.from(this.selectedDates)[0]);
        const _end = day.date;
        const [start, end] = [moment.min(_start, _end), moment.max(_start, _end)];
        while (start.isSameOrBefore(end, "d")) {
          this.selectedDates.add(start.format("YYYY-MM-DD"));
          start.add(1, "day");
        }
      } else {
        this.selectedDates = new Set([day.title]);
      }
    }
  }

  registerOnChange(fn: any): void {
    this._registerOnChange = fn;
  }

  registerOnTouched(fn: any): void {}

  writeValue(dates: string[]): void {
    this.selectedDates = new Set(dates);
  }
}
